import { FormattedMessage } from 'react-intl';
import LogoutIcon from '@mui/icons-material/Logout';
import { useMsal } from '@azure/msal-react';
import { Button } from '@mui/material';
import './LogoutButton.scss';

const LogoutButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({ account: instance.getActiveAccount() });
  };

  return (
    <Button className="logoutButton" onClick={handleLogout} startIcon={<LogoutIcon />}>
      <FormattedMessage id="app.logoutButton.text"></FormattedMessage>
    </Button>
  );
};

export default LogoutButton;
